<template>
  <div class="footer">
    <div class="container">
      <div class="footer-right">
        <img src="https://style-stg.ibuychem.com//wiseshop/pc/en/images/zc_logo_en_footer.png" alt="">
        <ul class="footer-left-ul2">
          <li><a href="https://en.ibuychem.com/" one-link-mark="yes">Home</a></li>
          <li><a href="https://www.hzeyun.com/research/tags/1541.html" target="_blank" one-link-mark="yes">News</a></li>
          <li><a href="https://ebook.hzeyun.com/44.html" target="_blank" one-link-mark="yes">Magazine</a></li>
        </ul>
        <ul class="footer-right-ul1">
          <li>Phone：+86 4009300360</li>
        </ul>
        <ul class="footer-right-ul2">
          <li>Email：info@ibuychem.com</li>
        </ul>
      </div>
      <div class="footer-left">
        <ul class="footer-right-ul3">
          <li>Address：<br>
            (China) Floor 19,Dongshan Ziyuan Building,745 Eastern Dongfeng Rd, Yuexiu District,
            Guangzhou<br>
            (Saudi Arabia) Office 20,Al musa center,Olaya Street,Riyadh,Saudi arabia<br>
            (Warehouse display center) 7663 Ibn Majah, 2324, As Sulay, Riyadh, Saudi Arabia<br>
            (Thailand) 168 Samanea Plaza Thailand Building, Room No. C060, Moo 7, Bang Sao Thong Subdistrict, Bang Sao
            Thong
            District Samut Prakan Province 10570
          </li>
        </ul>
      </div>
      <link rel="stylesheet" href="https://at.alicdn.com/t/c/font_4796008_gj9mil1aa8t.css">
      <div class="row" style="clear: both;">
        <div class="cms-social cms-social-item col-auto pb-10"> <a
            href="https://www.facebook.com/profile.php?id=61565912138553" target="_blank"
            class="d-flex align-items-center link-body link-hover-accent" one-link-mark="yes"> <span aria-hidden="true"
              class="cms-icon social-icon pr-10 text-20 text-primary text-hover-accent cmsi-facebook" style=""></span>
            <span class="social-name font-700">Facebook</span> </a></div>
        <div class="cms-social cms-social-item col-auto pb-10"> <a href=" https://www.linkedin.com/company/104988252"
            target="_blank" class="d-flex align-items-center link-body link-hover-accent iconfont icon-lingyingshi"
            one-link-mark="yes"> <span aria-hidden="true"
              class="cms-icon social-icon pr-10 text-20 text-primary text-hover-accent " style=""></span> <span
              class="social-name font-700">Linkedin</span> </a></div>
        <div class="cms-social cms-social-item col-auto pb-10"> <a href=" https://www.youtube.com/@iBuychem-k2v"
            target="_blank" class="d-flex align-items-center link-body link-hover-accent" one-link-mark="yes"> <span
              aria-hidden="true"
              class="cms-icon social-icon pr-10 text-20 text-primary text-hover-accent cmsi cmsi-youtube"
              style=""></span> <span class="social-name font-700">Youtube</span> </a></div>
        <div class="text-body text-end returntop" @click="scrollToTop">
          <a class="cms-anchor d-flex align-items-center justify-content-end text-accent text-hover-primary"
            href="javascript:;" one-link-mark="yes">Back To Top<span class="text-12 pl-20"> <span aria-hidden="true"
                class="cms-icon rtl-flip d-block cms-anchor-icon cmsi-arrow-up-2"></span> </span></a>
        </div>
      </div>

      <a href="https://en.ibuychem.com/privacy-policy" class="ystk" target="_blank" one-link-mark="yes">Privacy
        Policy</a>

    </div>
  </div>
</template>

<script>
  import config from '../../common/config';
  export default {
    data() {
      return {
        randomImageSpecial: null // 随机特版
      }
    },
    mounted() {
      // 显示随机特版
      this.randomImageSpecial = createRandomImageSpecial(config.ENV);
    },
    beforeDestroy() {
      this.randomImageSpecial && this.randomImageSpecial.remove();
    },
    methods: {
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  .footer {
    padding: 30px 0 20px;
    background: url(https://style-cdn.ibuychem.com//wiseshop/pc/en/images/footerbg.png) no-repeat center top #3b3a98;
    overflow: hidden;
    color: #fff;
    font-size: 16px;
    line-height: 32px;
    box-sizing: border-box;

    ul {
      li {
        line-height: 32px;
      }
    }
  }

  .footer-right .footer-left-ul2 {
    overflow: hidden;
    width: 94%;
    margin: 0 0 20px;
    font-size: 24px;
    font-weight: bold;

    li {
      display: inline-block;
      font-size: 18px;
      margin-right: 20px;
      position: relative;

      a {
        color: white;
      }
    }
  }

  .icon-lingyingshi:before {
    font-size: 24px
  }

  .container {
    position: relative;
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }

  .footer-right {
    width: 100%;
    margin: 0 auto;
    float: none;
  }

  .footer-right h3 {
    font-size: 20px;
  }

  .footer-right .line2 {
    display: block;
    width: 120px;
    height: 1px;
    background: #fff;
    margin: 5px 0 10px;
  }

  .footer-right p {
    font-size: 14px;
  }

  .footer-right .footer-right-ul1 {
    font-size: 14px;
    padding-left: 30px;
    background: url(https://zt.ibuychem.com/crossborder/images/img__08.png) no-repeat 0 8px;
    background-size: 18px 17px;
    margin-bottom: 0;
  }

  .footer-right .footer-right-ul2 {
    font-size: 14px;
    padding-left: 30px;
    background: url(https://zt.ibuychem.com/crossborder/images/img_09.png) no-repeat 0 9px;
    background-size: 17px 12px;
    margin-bottom: 0;
  }

  .footer-right .footer-right-ul3 {
    font-size: 14px;
    padding-left: 30px;
    margin-bottom: 30px;
    background: url(https://zt.ibuychem.com/crossborder/images/img_22.png) no-repeat 0 9px;
    background-size: 12px 15px;
  }

  .footer-right img {
    width: 150px;
    margin-bottom: 10px;
  }

  .footer-left {
    width: auto;
    float: none;

    .footer-right-ul3 {
      background-size: 17px 22px;
      padding-left: 30px;
      margin-top: 0;
      font-size: 14px;
      margin-bottom: 80px;
      background: url(https://zt.ibuychem.com/crossborder/images/img_22.png) no-repeat 0 8px;
      background-size: 17px 22px;
      padding-left: 30px;
      margin-top: 0;
      font-size: 14px;
      margin-bottom: 20px;
    }
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-left: -20px;
    margin-right: -20px;
  }

  .col-auto {
    position: relative;
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .pb-10 {
    padding-bottom: 10px;
  }

  .font-700 {
    font-weight: 700 !important;
  }

  .text-20 {
    font-size: 20px;
  }

  .pr-10 {
    padding-right: 10px;
  }

  .footer .cms-social a,
  .footer .cms-social .text-primary {
    color: #fff !important;
  }

  [class^=cmsi-],
  [class*=" cmsi-"] {
    font-family: cmsi !important;
    speak: never;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .cmsi-facebook:before {
    content: "\e928";
  }

  .cmsi-youtube:before {
    content: "\e933";
  }

  .cms-icon {
    line-height: 1 !important;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  .d-flex {
    flex-wrap: wrap;
  }

  .align-items-center {
    align-items: center;
  }

  .d-flex {
    display: flex;
  }

  .text-end {
    text-align: end;
  }

  .text-body {
    color: #828599;
  }

  .returntop {
    margin-left: 5%;
  }

  .justify-content-end {
    justify-content: flex-end;
  }

  .align-items-center {
    align-items: center;
  }

  .cms-anchor {
    font-weight: 700;
  }

  .returntop a {
    color: #FF8D6B !important;
  }

  .cmsi-arrow-up-2:before {
    content: "\e979";
  }

  .text-12 {
    font-size: 12px;
  }

  .pl-20 {
    padding-left: 20px;
  }

  .ystk {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-right: -20px;
    color: #fff;
    margin-left: 0;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue